import moment from 'moment';
import cs from 'classnames';
import { useContext } from 'react';
import { Space, Typography } from 'antd';
import { GuidesContext } from '../context/guides.context';
import Actions from './Actions';
import { IGuide } from '../../../interfaces/express-delivery.interface';

interface ColumnProps {
    title: string;
    dataIndex: string;
    key: string;
    align?: 'center' | 'left' | 'right';
    render?: (value: any, record: any) => React.ReactNode;
}

const { Text } = Typography;

const InitialColumns = () => {
    const { setItemSelected } = useContext(GuidesContext);

    const INITIAL_COLUMNS: ColumnProps[] = [
        {
            title: 'Numeric ID',
            dataIndex: 'guideNumericId',
            key: 'guideNumericId',
            render: (text: string) => (
                <Text>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Date & Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text: string) => {
                const date = moment(text).format('dddd, D MMM');
                const time = moment(text).format('h:mm a');
                return (
                    <Space direction="vertical" size={4}>
                        <Text>
                            {date}
                        </Text>
                        <Text>
                            {time}
                        </Text>
                    </Space>
                );
            },
        },
        {
            title: 'Workspace',
            dataIndex: 'workspaceName',
            key: 'workspaceName',
            render: (text: string) => (
                <Text>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Business',
            dataIndex: 'businessName',
            key: 'businessName',
            render: (text: string) => (
                <Text>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text: string) => (
                <Text className={cs(text, 'status')}>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Origin',
            dataIndex: 'origin',
            key: 'origin',
            render: (text: string) => (
                <Text className={cs(text, 'status')}>
                    {text}
                </Text>
            ),
        },
        {
            title: 'Actions',
            dataIndex: '_id',
            key: 'actions',
            align: 'center' as 'center',
            render: (_id: string, record: IGuide) => (
                <Actions
                    item={record}
                    setItemSelected={setItemSelected}
                />
            ),
        },
    ];

    return INITIAL_COLUMNS;
};

export default InitialColumns;
